import type { HTMLAttributes, LabelHTMLAttributes } from "react";
import { forwardRef } from "react";

import { tw } from "@/shared/utils";

const Root = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      className={tw("rounded-2xl bg-white px-4 md:hidden", className)}
      {...props}
    />
  ),
);
Root.displayName = "TableCard.Root";

const Row = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      className={tw(
        "flex flex-col gap-3 border-b border-neutral-400 py-4 last:border-b-0",
        className,
      )}
      {...props}
    />
  ),
);
Row.displayName = "TableCard.Row";

const Cell = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      className={tw("flex justify-between gap-2", className)}
      {...props}
    />
  ),
);
Cell.displayName = "TableCard.Cell";

const Label = forwardRef<
  HTMLLabelElement,
  LabelHTMLAttributes<HTMLLabelElement>
>(({ className, htmlFor, ...props }, ref) => (
  <label
    htmlFor={htmlFor}
    ref={ref}
    className={tw("text-neutral-900", className)}
    {...props}
  />
));
Label.displayName = "TableCard.Label";

const Data = forwardRef<
  HTMLParagraphElement,
  HTMLAttributes<HTMLParagraphElement>
>(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={tw("font-semibold text-neutral-950", className)}
    {...props}
  />
));
Data.displayName = "TableCard.Data";

export const TableCard = { Root, Row, Cell, Label, Data };
